// extracted by mini-css-extract-plugin
module.exports = {"menuColor":"#141414","menuTextColor":"#f5f5f5","menuActiveTextColor":"#409eff"};